import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Tabs, Tree } from 'antd'

import classNames from 'classnames'

import { EmptyData } from 'utils/ui'

import dataManager from 'pages/main/data/DataManager'

import { getImageByRole } from 'pages/main/data/IconHelper'

import rightIcon from 'assets/images/mailbox/chevron-right-24.svg'
import downIcon from 'assets/images/mailbox/chevron-down-24.svg'
// import close24Icon from 'assets/images/icon-search-clear.svg'
// import search24Icon from 'assets/images/toolbar-search-gray.svg'

// import NormalItem from './normalItem'
import MailboxItem from './mailboxItem'

import styles from './style.module.scss'
import Search from 'components/Search'

interface MailboxSelectorProps extends WithTranslation {
  exceptRole?: string[]
  except?: any[]
  enableRoot?: boolean
  onSelectItem?: (item: any) => void
  onTabChange?: (activeKey: string) => void
  defaultActiveKey?: string
  tabs?: string[]
  hideTabs?: boolean
}

interface MailboxSelectorState {
  recentList: any[]
  resultList: any[] | null
  favoriteList: any[] | null
  selectedKeysForAll: string[]
  searchValue: string
}

class MailboxSelector extends React.Component<MailboxSelectorProps, MailboxSelectorState> {
  state: MailboxSelectorState = {
    recentList: [],
    resultList: null,
    favoriteList: null,
    selectedKeysForAll: [],
    searchValue: '',
  }

  inputRef = React.createRef<any>()

  selectedItem: any = null

  exceptRoleList: string[] = []

  exceptMailboxList: any[] | null = null

  rootItem: any = null

  allMailboxs: any[] = []

  tree: any = null

  constructor(props: MailboxSelectorProps) {
    super(props)

    const { exceptRole, except } = this.props

    this.exceptRoleList = exceptRole || ['drafts', 'trash']
    this.exceptMailboxList = except || null
  }

  componentDidMount() {
    this.onMailBoxChanged()

    this.initData()
    ;(dataManager as any).addMailboxChangeListener(this.onMailBoxChanged)
  }

  // componentDidUpdate(prevProps) {
  //   const { visibleState } = this.props;

  //   if (prevProps.visibleState !== visibleState) {
  //     this.initData();
  //   }
  // }

  componentWillUnmount() {
    ;(dataManager as any).removeMailboxChangeListener(this.onMailBoxChanged)
  }

  initData = () => {
    // this.setAllFoldersOpen(false)
    this.setState({
      resultList: null,
      favoriteList: null,
    })

    if (this.inputRef.current != null) {
      this.inputRef.current.value = ''
    }

    this.setDefaultFolders()
    this.applyFavoriteList()
    this.applyRecentList()
  }

  onOpenChange = (open: boolean) => {
    console.log('onOpenChange - ', open)
    if (open === true) {
      this.initData()
    }
  }

  onMailBoxChanged = () => {
    this.allMailboxs = dataManager.getAllMailboxes().filter((item: any) => {
      return this.isSelectableMailbox(item)
    })
    // this.setState({
    //   allMailboxs: this.allMailboxs,
    // })
  }

  getMailboxById = (id: string) => {
    const { enableRoot } = this.props
    if (enableRoot === true && id === '__root__') {
      return this.rootItem
    }
    return dataManager.getMailboxById(id, true)
  }

  isSelectableMailbox = (mailbox: any) => {
    const role = mailbox.getRole()

    if (this.exceptRoleList != null && this.exceptRoleList.indexOf(role) > -1) {
      return false
    }

    if (this.exceptMailboxList != null) {
      const existItem = this.exceptMailboxList.find((item: any) => {
        return item.getId() === mailbox.getId()
      })

      if (existItem != null) {
        return false
      }
    }

    return true
  }

  getRootItem = () => {
    const { enableRoot } = this.props

    if (this.rootItem == null && enableRoot === true) {
      this.rootItem = dataManager.getRootMailbox()
    }

    return this.rootItem
  }

  getRootMailboxes = () => {
    const { enableRoot } = this.props

    let rootFolders = dataManager.getRootMailboxes()

    if (enableRoot === true) {
      const rootItem = this.getRootItem()
      rootItem.list = [...rootFolders]

      rootFolders = [rootItem]
    }

    return rootFolders
  }

  makeMailboxList = (mailboxList: any[]) => {
    const { selectedKeysForAll } = this.state

    let menu = null

    if (mailboxList != null && mailboxList.length > 0) {
      // const defaultSelectedKeys = []

      const hasChildren = (item: any) => {
        return item.list != null && item.list.length > 0
      }

      const makeList = (mailboxList: any[], parentItems: any[]) => {
        return mailboxList.forEach((item: any) => {
          const selectable = this.isSelectableMailbox(item)
          const hasChild = hasChildren(item)
          if (selectable === true || hasChild === true) {
            const role = item.getRole()
            const isRoot = item === this.rootItem
            const menuItem: any = {
              title: (
                <span className={classNames('mailbox', { root: isRoot })}>
                  <span className={classNames('title')}>{item.getDisplayName()}</span>
                </span>
              ),
              key: item.getId(),
              icon: getImageByRole(role),
              selectable,
              disabled: !selectable,
            }

            parentItems.push(menuItem)

            if (hasChild === true) {
              menuItem.children = []
              makeList(item.list, menuItem.children)
            }
          }
        })
      }

      const items: any[] = []
      makeList(mailboxList, items)

      const treeAttrs = {
        className: classNames('mailboxTree', 'moveMailbox', styles.scrollView),
        ref: (ref: any) => {
          this.tree = ref
          if (this.tree != null && this.tree._tmpOnNodeSelect == null) {
            const self = this
            self.tree._tmpOnNodeSelect = self.tree.onNodeSelect
            self.tree.onNodeSelect = function (e: any, treeNode: any) {
              if (treeNode.selected === true) return
              self.tree._tmpOnNodeSelect(e, treeNode)
            }
          }
        },
        checkable: false,
        treeData: items,
        showIcon: true,
        defaultExpandAll: true,
        autoExpandParent: true,
        selectable: true,
        // defaultSelectedKeys,
        selectedKeys: selectedKeysForAll,
        switcherIcon: (treeNodeProp: any) => {
          // console.log(' - treeNodeProp', treeNodeProp);
          if (treeNodeProp.expanded === true) {
            return <img src={downIcon} />
          }
          return <img src={rightIcon} />
        },
        // onClick: (e, treeNode) => {
        //   console.log(' --- onClick : ', e, treeNode)
        // },
        onSelect: (selectedKeys: string[]) => {
          if (selectedKeys.length > 0) {
            const key = selectedKeys[0]
            const mailbox = this.getMailboxById(key)
            // console.log('tree : selected', mailbox);
            this.setSelectedItem(mailbox)
          }

          this.setState({
            selectedKeysForAll: [...selectedKeys],
          })
        },
      }

      menu = <Tree {...(treeAttrs as any)} />
    }

    return menu
  }

  setDefaultFolders = () => {
    // const defaultEmptyView = this.allFoldersOpen === true

    // if (defaultEmptyView !== true) {
    //   dataManager.getRecentMoveMailboxIdList().then((res) => {
    //     const list = res || []

    //     let resultList = list
    //       .map((id) => {
    //         return this.getMailboxById(id)
    //       })
    //       .filter((mailbox) => mailbox != null && this.isSelectableMailbox(mailbox))

    //     if (resultList.length === 0) {
    //       resultList = this.allMailboxs
    //     }

    //     this.setState({
    //       resultList,
    //     })
    //   })
    // } else {
    this.setState({
      resultList: [],
    })
    // }
  }

  getSelectedItem = () => {
    return this.selectedItem
  }

  setSelectedItem = (item: any) => {
    const { onSelectItem } = this.props
    if (this.selectedItem != item) {
      this.selectedItem = item

      if (onSelectItem != null) {
        onSelectItem(this.selectedItem)
      }

      this.forceUpdate()
    }
  }

  search = (txt: string) => {
    const sText = (txt || '').toLowerCase().trim()
    if (sText.length > 0) {
      const resultList = this.allMailboxs.filter((item: any) => {
        if (item.getDisplayName().toLowerCase().indexOf(sText) > -1) {
          return true
        }
        if (item.getRole().toLowerCase().indexOf(sText) > -1) {
          return true
        }
        return false
      })

      this.setState({
        resultList,
      })
    } else {
      this.setDefaultFolders()
    }
  }

  // appendRecentList = (mailboxId) => {
  //   dataManager.addRecentMoveMailboxId(mailboxId).then(() => {
  //     this.applyRecentList()
  //   })
  // }

  applyRecentList = () => {
    dataManager.getRecentMoveMailboxIdList().then((res: any) => {
      const list = res || []

      let recentList = list
        .map((id: string) => {
          return this.getMailboxById(id)
        })
        .filter((mailbox: any) => mailbox != null && this.isSelectableMailbox(mailbox))

      this.setState({
        recentList,
      })
    })
  }

  applyFavoriteList = () => {
    dataManager.getFavoriteMailboxIdList().then((res: any) => {
      const list = res || []

      const favoriteList = list
        .sort((a: any, b: any) => {
          if (a.order > b.order) {
            return 1
          } else if (a.order < b.order) {
            return -1
          }
          return 0
        })
        .map((favoriteItem: any) => {
          const { id } = favoriteItem
          const mailbox = this.getMailboxById(id)
          return mailbox
        })
        .filter((mailbox: any) => {
          return mailbox != null && mailbox.isRealMailbox === true
        })

      this.setState({
        favoriteList,
      })
    })
  }

  // setAllFoldersOpen = (open) => {
  //   this.allFoldersOpen = open
  //   this.setState({
  //     allFoldersOpen: this.allFoldersOpen,
  //   })
  // }

  onChange = (value: string) => {
    console.log(' onChange - ', value)
    this.search(value)
    this.setState({ searchValue: value })
  }

  renderSearch = () => {
    const { resultList } = this.state
    const { t } = this.props

    let resultListElem = null
    if (resultList != null && resultList.length > 0) {
      resultListElem = resultList.map((mailbox: any) => {
        return <MailboxItem item={{ mailbox }} key={mailbox.getId()} owner={this} />
      })
    } else {
      resultListElem = <EmptyData type="search" mailbox={null as any} />
    }

    return (
      <React.Fragment>
        <div className={classNames(styles.selectorItem, styles.searchWrapper)}>
          <Search
            value={this.state.searchValue || ''}
            onChange={(e: any) => this.onChange(e.target.value)}
            onClear={() => this.onChange('')}
            className={classNames(styles.search)}
            placeholder={t('email.moveFolder.placeholder')}
          />
        </div>
        <div
          className={classNames(styles.mailboxList)}
          style={{ flexDirection: 'column', minHeight: 322, maxHeight: 322 }}
        >
          {resultListElem}
        </div>
      </React.Fragment>
    )
  }

  renderAll = () => {
    // const { enableRoot } = this.props
    // const { allMailboxs } = this.state

    // const allFoldersElem = allMailboxs.map((mailbox) => {
    //   return (
    //     <MailboxItem indent item={{ mailbox }} key={mailbox.getId()} owner={this} />
    //   )
    // })

    const rootFolders = this.getRootMailboxes()

    const mailboxesElem = this.makeMailboxList(rootFolders)

    // const allFoldersBtn = (
    //   <NormalItem
    //     item={{
    //       key: 'allFolders',
    //       label: t('email.moveFolder.allFolders'),
    //       icon: <img src={moreCircle24Icon} alt="all folders" />,
    //     }}
    //     owner={this}
    //   />
    // )

    // return (
    //   <React.Fragment>
    //     {allFoldersElem}
    //     <div className={classNames(styles.dividerItem)} />
    //     {mailboxesElem}
    //   </React.Fragment>
    // )
    return <React.Fragment>{mailboxesElem}</React.Fragment>
  }

  renderFavorite = () => {
    const { favoriteList } = this.state

    let favoriteListElem = null
    if (favoriteList != null && favoriteList.length > 0) {
      favoriteListElem = (
        <React.Fragment>
          {favoriteList.map((mailbox: any) => (
            <MailboxItem item={{ mailbox }} key={mailbox.getId()} owner={this} />
          ))}
        </React.Fragment>
      )
    } else {
      favoriteListElem = <EmptyData type="favoriteFolder" mailbox={null as any} />
    }

    return <div className={classNames('recentList')}>{favoriteListElem}</div>
  }

  renderRecent = () => {
    const { recentList } = this.state

    let recentListElem = null
    if (recentList != null && recentList.length > 0) {
      recentListElem = (
        <React.Fragment>
          {recentList.map((mailbox: any) => (
            <MailboxItem item={{ mailbox }} key={mailbox.getId()} owner={this} />
          ))}
        </React.Fragment>
      )
    } else {
      recentListElem = <EmptyData type="recentFolder" mailbox={null as any} />
    }

    return <div className={classNames('recentList')}>{recentListElem}</div>
  }

  getTabItems = () => {
    const { t, tabs } = this.props

    const items = [
      {
        key: 'search',
        label: t('mailbox.moveTab.search'),
        children: this.renderSearch(),
      },
      {
        key: 'recents',
        label: t('mailbox.moveTab.recents'),
        children: this.renderRecent(),
      },
      {
        key: 'folders',
        label: t('mailbox.moveTab.folders'),
        children: this.renderAll(),
      },
      {
        key: 'favorites',
        label: t('mailbox.moveTab.favorites'),
        children: this.renderFavorite(),
      },
    ]

    if (tabs == null) {
      return items
    } else {
      const itemMap: Record<string, any> = {}
      items.forEach((item) => {
        itemMap[item.key] = item
      })
      return tabs
        .map((key: string) => {
          return itemMap[key]
        })
        .filter((item: any) => {
          return item != null
        })
    }
  }

  render() {
    const { onTabChange, defaultActiveKey, hideTabs } = this.props
    const items = this.getTabItems()

    const tabsAttrs = {
      className: classNames('custom-tabs-nav', { 'hide-tabs-nav': hideTabs }),
      items,
      centered: true,
      defaultActiveKey: defaultActiveKey || 'folders',
      onChange: (activeKey: string) => {
        if (activeKey === 'folders') {
          this.setState({
            selectedKeysForAll: [],
          })
        }
        if (onTabChange != null) {
          onTabChange(activeKey)
        }
        this.setSelectedItem(null)
      },
    }

    return (
      <div className={classNames(styles.mailboxSelector)}>
        <Tabs {...tabsAttrs} />
      </div>
    )
  }
}

const MailboxSelectorDef = withTranslation()(MailboxSelector)

export default MailboxSelectorDef
